import { DEFAULT_SEO, SITE_URL } from "./constants";

export const generateMetadata = ({
    title,
    description,
    image,
    path,
}) => {
    const metaTitle =
        title || DEFAULT_SEO.title;

    const metaDescription =
        description || DEFAULT_SEO.description;

    const metaImage =
        image || DEFAULT_SEO.image;

    const canonicalUrl =
        `${SITE_URL}${path}`;

    return {
        title: metaTitle,
        description: metaDescription,
        image: metaImage,
        canonicalUrl,
    };
};